<div class='UploadMoveDialog'>
  <ng-container *ngIf='state === states.SELECT_TEMPLATE'>
    <div [formGroup]='inputForm' class='select-template'>
      <div class='alert alert-info'>
        <p>V1 - if you know the email addresses only
          <app-button [Click]='downloadTemplateByEmailButton.onClick' [color]='downloadTemplateByEmailButton.color'
                      [size]='downloadTemplateByEmailButton.size'
                      [text]='downloadTemplateByEmailButton.text'></app-button>
        </p>
        <p>V2 - if you know the exact contact IDs
          <app-button [Click]='downloadTemplateByIdButton.onClick' [color]='downloadTemplateByIdButton.color'
                      [size]='downloadTemplateByIdButton.size'
                      [text]='downloadTemplateByIdButton.text'></app-button>
        </p>
        <ul>
          <p>NOTES:</p>
          <li>With v1 template, contacts will be moved to group name "Moved Contacts" of the destination account</li>
          <li>NOTE: With v2 template, you can define the exact destination contact group id, owned by the destination
            account
          </li>
          <li>NOTE: At process completion, in column "Status" the result per contact will be displayed.</li>
        </ul>
      </div>
      <mat-radio-group
        class='select-template--radio-group'
        formControlName='template'>
        <mat-radio-button
          [value]='templates.V1'
          class='select-template--radio-button'
        >V1
        </mat-radio-button
        >
        <mat-radio-button
          [value]='templates.V2'
          class='select-template--radio-button'
        >V2
        </mat-radio-button
        >
      </mat-radio-group>
    </div>
  </ng-container>
</div>
